import { NavLink } from 'react-router-dom'
import { useAuth } from '../../auth/AuthContext'
import { canManageMall as roleCanManageMall, canSell as roleCanSell } from '../../auth/roles'

// Secondary nav inside the SellerLayout. Shows the seller-tier links to anyone
// who can sell, and the mall-management links only to mall owners/admins.
// Prefers the server-provided capability flags, falling back to role.
export default function SellerNav() {
  const { user } = useAuth()
  if (!user) return null

  const manageMall = user.canManageMall ?? roleCanManageMall(user.role)
  const sell = user.canSell ?? roleCanSell(user.role)
  if (!sell) return null

  const cls = ({ isActive }: { isActive: boolean }) => (isActive ? 'is-active' : '')
  return (
    <nav className="seller-nav">
      <NavLink to="/manage/store" className={cls}>My Store</NavLink>
      {manageMall && (
        <>
          <NavLink to="/manage/stores" className={cls}>Stores</NavLink>
          <NavLink to="/manage/products" className={cls}>Products</NavLink>
          <NavLink to="/manage/mall" className={cls}>Mall</NavLink>
        </>
      )}
      <NavLink to="/" end className={cls}>Streams</NavLink>
    </nav>
  )
}
